module.exports = __webpack_public_path__ + "img/43.112562b.jpg";